import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FileDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AccountingEntryNumberModeEnum, AccountingEntryNumberModeService, AccountingEntryNumberModeType } from '~modules/connectors/modules/load/common/services/accounting-number-mode.service';
import { LetteringScopeEnum, LetteringScopeService, LetteringScopeType } from '~modules/connectors/modules/load/common/services/lettering-scope.service';

@Component({
  selector: 'app-basic-load-configuration-options',
  standalone: true,
  providers: [AccountingEntryNumberModeService, LetteringScopeService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule],
  styleUrls: ['./basic-load-configuration-options.component.scss'],
  templateUrl: './basic-load-configuration-options.component.html'
})
export class BasicLoadConfigurationOptionsComponent {

  internalFormGroup?: FormGroup;
  configMode: string | undefined;
  fieldsConfig?: FileDownloadFieldsConfiguration;
  accountingNumberModeList!: AccountingEntryNumberModeType[];
  letteringScopeList!: LetteringScopeType[];

  @Input({ required: true })
  set formGroup(formGroup: FormGroup) {
    this.internalFormGroup = formGroup;
    this.internalFormGroup.setControl('generatePartialLettering', new FormControl(false, Validators.required));
    this.internalFormGroup.setControl('accountingEntryNumberMode', new FormControl(AccountingEntryNumberModeEnum.NONE, Validators.required));
    this.internalFormGroup.setControl('removeSpecialCharacters', new FormControl(false));
    this.internalFormGroup.setControl('letteringScope', new FormControl(LetteringScopeEnum.BY_ACCOUNT, Validators.required));
    this.updateFormWithConfiguration();
  }

  @Input()
  set configurationMode(configMode: string | undefined) {
    this.configMode = configMode;
  }

  @Input()
  set configuration(fieldsConfig: FileDownloadFieldsConfiguration | undefined) {
    this.fieldsConfig = fieldsConfig;
    this.updateFormWithConfiguration();
  }

  updateFormWithConfiguration() {
    if (this.internalFormGroup != null && this.fieldsConfig != null) {
      this.internalFormGroup.get('generatePartialLettering')?.setValue(this.fieldsConfig.generatePartialLettering.defaultValue);
      this.internalFormGroup.get('accountingEntryNumberMode')?.setValue(this.fieldsConfig.accountingEntryNumberMode.defaultValue);
      this.internalFormGroup.get('removeSpecialCharacters')?.setValue(this.fieldsConfig.removeSpecialCharacters.defaultValue);
      this.internalFormGroup.get('letteringScope')?.setValue(this.fieldsConfig.letteringScope.defaultValue);
    }
  }

  constructor(
    readonly accountingEntryNumberModeService: AccountingEntryNumberModeService,
    readonly letteringScopeService: LetteringScopeService
  ) {
    this.accountingNumberModeList = accountingEntryNumberModeService.getAll();
    this.letteringScopeList = letteringScopeService.getAll();
  }
}
